<template>
    <svg height="18.66" viewBox="0 0 18.66 18.66" width="18.66" xmlns="http://www.w3.org/2000/svg">
        <g id="Icon_feather-settings" data-name="Icon feather-settings" transform="translate(-0.5 -0.5)">
            <path
                id="Path_2223"
                d="M18.044,15.772A2.272,2.272,0,1,1,15.772,13.5,2.272,2.272,0,0,1,18.044,15.772Z"
                data-name="Path 2223"
                fill="none"
                stroke="#1bc5bd"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                transform="translate(-5.942 -5.942)"
            />
            <path
                id="Path_2224"
                d="M15.434,12.1a1.25,1.25,0,0,0,.25,1.378l.045.045a1.515,1.515,0,1,1-2.143,2.143l-.045-.045a1.26,1.26,0,0,0-2.136.894v.129a1.515,1.515,0,0,1-3.029,0v-.068a1.25,1.25,0,0,0-.818-1.143,1.25,1.25,0,0,0-1.378.25l-.045.045a1.515,1.515,0,1,1-2.143-2.143l.045-.045a1.26,1.26,0,0,0-.894-2.136H3.015a1.515,1.515,0,0,1,0-3.029h.068a1.25,1.25,0,0,0,1.143-.818,1.25,1.25,0,0,0-.25-1.378l-.045-.045A1.515,1.515,0,1,1,6.074,3.991l.045.045a1.25,1.25,0,0,0,1.378.25h.061a1.25,1.25,0,0,0,.757-1.143V3.015a1.515,1.515,0,0,1,3.029,0v.068a1.26,1.26,0,0,0,2.136.894l.045-.045a1.515,1.515,0,1,1,2.143,2.143l-.045.045a1.25,1.25,0,0,0-.25,1.378v.061a1.25,1.25,0,0,0,1.143.757h.129a1.515,1.515,0,0,1,0,3.029h-.068a1.25,1.25,0,0,0-1.143.757Z"
                data-name="Path 2224"
                fill="none"
                stroke="#1bc5bd"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "Actions",
};
</script>
